import {Pipe, PipeTransform} from '@angular/core';

import {FormFieldType} from "../enums/form-field-type.enum";

@Pipe({name: 'fieldCanBePrefilled'})
export class FieldCanBePrefilledPipe implements PipeTransform {
  transform(value: string): boolean {
    const fieldType = value as FormFieldType;
    return fieldType === FormFieldType.TEXT || fieldType === FormFieldType.HIDDEN || fieldType === FormFieldType.TEXTAREA;
  }
}
